const moneyFmt = new Intl.NumberFormat('es-GT', {
  style: 'currency',
  currency: 'GTQ',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function fmtMoney(value: string | number): string {
  const n = typeof value === 'string' ? Number(value) : value;
  return Number.isFinite(n) ? moneyFmt.format(n) : '—';
}

const moneyWholeFmt = new Intl.NumberFormat('es-GT', {
  style: 'currency',
  currency: 'GTQ',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Money rounded to whole quetzales — for dashboard KPI tiles and summaries where
 * centavos are noise and long values would otherwise break mid-number. Detail
 * screens (contracts, payments, statements) keep centavos via `fmtMoney`.
 */
export function fmtMoneyWhole(value: string | number): string {
  const n = typeof value === 'string' ? Number(value) : value;
  return Number.isFinite(n) ? moneyWholeFmt.format(n) : '—';
}

/** `fraction` is a decimal rate string/number, e.g. "0.18" → "18.00%". */
export function fmtPct(fraction: string | number, digits = 2): string {
  const n = typeof fraction === 'string' ? Number(fraction) : fraction;
  return Number.isFinite(n) ? `${(n * 100).toFixed(digits)}%` : '—';
}

/** `iso` is a date-only string "YYYY-MM-DD". Rendered in es-GT without timezone drift. */
export function fmtDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return new Intl.DateTimeFormat('es-GT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(y, m - 1, d));
}

/** Coerce a numeric form input to a NUMERIC(15,2) string ("1000" → "1000.00"). Empty → "". */
export function toMoneyString(input: string): string {
  const trimmed = input.trim();
  if (trimmed === '') return '';
  const n = Number(trimmed);
  return Number.isFinite(n) ? n.toFixed(2) : '';
}

/** Convert a percent form input to a decimal fraction string ("18" → "0.18"). Empty → "". */
export function percentToFraction(input: string): string {
  const trimmed = input.trim();
  if (trimmed === '') return '';
  const n = Number(trimmed);
  return Number.isFinite(n) ? (n / 100).toString() : '';
}
